module.exports = __webpack_public_path__ + "img/horizontal_1_1_5012.2f949ebc.png";